import { render, staticRenderFns } from "./NewRanterModel.vue?vue&type=template&id=0da6f0a1&"
import script from "./NewRanterModel.vue?vue&type=script&lang=ts&"
export * from "./NewRanterModel.vue?vue&type=script&lang=ts&"
import style0 from "./NewRanterModel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports